import type { TransferAccountBalance } from './transfer-account-balances.model';

export interface GenerateTransferAccountBalanceOptions {
  readonly accountNumber?: string;
  readonly customerId?: number;
  readonly balances?: TransferAccountBalance['balances'];
}

export function generateTransferAccountBalanceObject({
  accountNumber = '2415267',
  customerId = 1,
  balances = { usd: 100 },
}: GenerateTransferAccountBalanceOptions = {}): TransferAccountBalance {
  return {
    id: accountNumber,
    customerId,
    balances,
  };
}
